module.exports = __webpack_public_path__ + "static/kb-sorunlar-fcbb244d8dcabe02000c6e348eaf8b53.png";